<p-dialog
  class="action-item-modal b1 font-medium admin-users-modal"
  header="{{ isEdit ? 'Update User' : 'Add User' }}"
  [modal]="true"
  [(visible)]="isUserModalVisible"
  [style]="{ width: '50rem' }"
  (onHide)="closeUserModal.emit(false)"
>
  <div class="wrapper p-l-20 p-r-20 p-t-25 p-b-25">
    <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
      <div
        class="users-form-container radius-8 border-20 p-t-15 p-b-15 p-l-15 p-r-15"
      >
        <!-- Name Field -->
        <div class="flex flex-column mb-3">
          <div class="dis-flex">
            <label class="b3 text-90" for="name"
              >Name <span class="mandatory">*</span></label
            >
            <span
              class="error-message"
              *ngIf="
                formGroup.get('name')?.invalid && formGroup.get('name')?.touched
              "
            >
              Name is required
            </span>
          </div>
          <input
            class="b3 text-90"
            placeholder="Enter Name"
            id="name"
            type="text"
            formControlName="name"
          />
        </div>

        <!-- Email Field -->
        <div class="flex flex-column mb-3">
          <div class="dis-flex">
            <label class="b3 text-90" for="email"
              >Email <span class="mandatory">*</span></label
            >
            <span
              class="error-message"
              *ngIf="
                formGroup.get('email')?.hasError('required') &&
                formGroup.get('email')?.touched
              "
            >
              Email is required
            </span>
            <span
              class="error-message"
              *ngIf="
                formGroup.get('email')?.hasError('email') &&
                formGroup.get('email')?.touched
              "
            >
              Enter a valid email address
            </span>
          </div>
          <input
            id="email"
            class="b3 text-90"
            placeholder="Enter Email"
            type="email"
            formControlName="email"
          />
        </div>

        <!-- Designation -->
        <div class="row">
          <div class="col-md-4">
            <div class="flex flex-column mb-3">
              <div class="dis-flex">
                <label class="b3 text-90"
                  >Designation <span class="mandatory">*</span></label
                >
                <span
                  class="error-message"
                  *ngIf="
                    formGroup.get('designation')?.invalid &&
                    formGroup.get('designation')?.touched
                  "
                >
                  Designation is required
                </span>
              </div>
              <p-autoComplete
                class="designation-wrapper"
                [suggestions]="designations"
                (completeMethod)="onDesignationSearch($event)"
                formControlName="designation"
              />
            </div>
          </div>

          <!-- Gender -->
          <div class="col-md-4">
            <div class="flex flex-column mb-3">
              <div class="dis-flex">
                <label class="b3 text-90"
                  >Gender <span class="mandatory">*</span></label
                >
                <span
                  class="error-message"
                  *ngIf="
                    formGroup.get('gender')?.invalid &&
                    formGroup.get('gender')?.touched
                  "
                >
                  Gender is required
                </span>
              </div>
              <p-dropdown
                class="b3 text-90"
                formControlName="gender"
                [options]="gender"
                placeholder="Select Gender"
                [overlayOptions]="helper.getOverlayOptions()"
              >
              </p-dropdown>
            </div>
          </div>

          <!-- Manager -->
          <div class="col-md-4">
            <div class="flex flex-column mb-3">
              <div class="dis-flex">
                <label class="b3 text-90"
                  >Manager</label
                >
              </div>
              <p-dropdown
                (onFilter)="onManagerSearch($event)"
                class="b3 text-90"
                optionLabel="name"
                optionValue="user_id"
                formControlName="manager_id"
                [options]="managerList"
                placeholder="Select Manager"
                [overlayOptions]="helper.getOverlayOptions()"
                filter="true"
              >
              </p-dropdown>
            </div>
          </div>
        </div>

        <div class="row">
          <!-- Admin Checkbox -->
          <div class="col-md-4">
            <p-checkbox
              class="b3 text-90"
              formControlName="is_admin"
              label="Admin"
              [binary]="true"
            />
          </div>

          <!-- Affiliate Checkbox -->
          <div class="col-md-4">
            <p-checkbox
              class="b3 text-90"
              formControlName="is_affiliate"
              label="Affiliate"
              [binary]="true"
            />
          </div>

          <!-- IEL Checkbox -->
          <div class="col-md-4">
            <p-checkbox
              class="b3 text-90"
              formControlName="is_iel"
              [binary]="true"
              (onChange)="onIsIelChange($event.checked)"
              label="IEL"
            >
            </p-checkbox>
          </div>
        </div>

        <!-- Group Selection (Only if IEL is checked) -->
        <div class="col-md-12 m-t-20" *ngIf="formGroup.get('is_iel')?.value">
          <div class="flex flex-column mb-3">
            <div class="dis-flex">
              <label class="b3 text-90"
                >Group <span class="mandatory">*</span></label
              >
              <span
                class="error-message"
                *ngIf="
                  formGroup.get('groups')?.invalid &&
                  formGroup.get('groups')?.touched
                "
              >
                Group is required
              </span>
            </div>
            <p-multiSelect
              class="b3 text-90"
              [overlayOptions]="helper.getOverlayOptions()"
              formControlName="groups"
              [options]="groupListData"
              (onFilter)="onGroupSearch($event)"
              placeholder="Select Groups"
              filter="true"
              [showClear]="true"
              required
            >
              <ng-template let-value pTemplate="selectedItems">
                <div
                  class="inline-flex align-items-center gap-2 px-1"
                  *ngFor="let option of value; let i = index"
                >
                  <div>{{ option.name }}</div>
                  <button
                    type="button"
                    class="remove-button m-l-5 fs-13 radius-22"
                    (click)="removeGroup(option.group_id)"
                  >
                    ✖
                  </button>
                </div>
                <div *ngIf="!value || value.length === 0">Select Group</div>
              </ng-template>

              <ng-template let-user pTemplate="item">
                <div class="flex align-items-center gap-2">
                  <div>{{ user.name }}</div>
                </div>
              </ng-template>
            </p-multiSelect>
          </div>
        </div>
      </div>

      <div class="dis-flex flex-r m-t-20 m-b-20">
        <button
          class="btn outline wd-150px m-r-10"
          type="button"
          (click)="closeUserModal.emit(false)"
        >
          Cancel
        </button>
        <button
          class="btn primary wd-150px"
          type="submit"
          [disabled]="formGroup.invalid"
        >
          {{ isEdit ? "Update" : "Save" }}
        </button>
      </div>
    </form>
  </div>
</p-dialog>
